// Subtle Islamic decorative SVG accents
export const IslamicDivider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-3 ${className}`}>
    <span className="h-px w-12 bg-gradient-to-r from-transparent to-emerald-400" />
    <svg width="22" height="22" viewBox="0 0 24 24" className="text-emerald-600" fill="currentColor">
      <path d="M12 2l2.5 5.5L20 8l-4 4 1 6-5-3-5 3 1-6-4-4 5.5-.5z" opacity="0.85" />
    </svg>
    <span className="h-px w-12 bg-gradient-to-l from-transparent to-emerald-400" />
  </div>
);

export const IslamicPatternCorner = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" className={className} fill="none" aria-hidden="true">
    <g stroke="currentColor" strokeWidth="1.2" opacity="0.5">
      <path d="M100 10l30 30-30 30-30-30z" />
      <path d="M100 40l60 60-60 60-60-60z" />
      <circle cx="100" cy="100" r="20" />
      <path d="M100 60l40 40-40 40-40-40z" />
    </g>
  </svg>
);

export const ArchFrame = ({ children, className = "" }) => (
  <div className={`relative overflow-hidden rounded-t-[3rem] rounded-b-2xl ${className}`}>
    {children}
  </div>
);
